import { render, staticRenderFns } from "./ProfessionalForm.vue?vue&type=template&id=1c9dae22&scoped=true"
import script from "./ProfessionalForm.vue?vue&type=script&lang=ts"
export * from "./ProfessionalForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9dae22",
  null
  
)

export default component.exports